/*
 * Copyright © 2018-2025, GlobalVET AB
 *
 * All rights reserved. No part or the whole of this source code and the compiled program
 * may be reproduced, copied, distributed, disseminated to the public, adapted or transmitted
 * in any form or by any means, including photocopying, recording, or other electronic or
 * mechanical methods, without the prior written permission of GlobalVET AB. This source code
 * and the compiled program may only be used for the purposes of GlobalVET AB. This source code
 * and the compiled program shall be kept confidential and shall not be made public or made
 * available or disclosed to any unauthorized person. Any dispute or claim arising out of the
 * breach of these provisions shall be governed by and construed in accordance with the
 * laws of Sweden.
 */

import React from "react";
import { Link } from "react-router-dom";
import moment from "moment";
import { strings } from "../../../common/Strings/Strings";
import NumberFormatter from "../../../util/NumberFormatter";
import InvoiceActions from "../InvoiceDetails/InvoiceActions";
import { invoiceType } from "./InvoiceListRow";
import { InvoiceResponse } from "../../../models/invoice/InvoiceResponse";
import Button from "../../../components/Button";
import PetInfo from "../../Todo/PetInfo";

interface Props {
  invoice: InvoiceResponse;
  setError(error: string): void;
  reload(): void;
}

const PendingInvoiceListRow: React.FC<Props> = ({ invoice, setError, reload }: Props) => (
  <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-3 flex flex-col justify-between tw-card shadow divide-y dark:divide-gray-700">
    <div className="px-4 py-3 flex items-center font-bold">
      {invoice.customer.fullName || invoice.customer.organizationName}
      <div className="ml-auto">{NumberFormatter.formatPrice(invoice.totalCost, invoice.currency)}</div>
    </div>
    <div className="p-4 h-full space-y-4">
      <div>{invoice?.creationDate ? moment(invoice.creationDate).format("LLL") : ""}</div>
      {invoice?.pet ? (
        <PetInfo clinicPetDetails={{...invoice?.pet, chronicDiseases: invoice.pet?.chronicDiseases || []}} />
      ) : (
        <></>
      )}
      {invoiceType(invoice)}
    </div>
    <div className="p-4 flex items-center">
      <div>
        <Link to={`/invoices/edit/${invoice.id}/finish`} style={{ lineHeight: 0 }}>
          <Button fullWidth={false}>{strings.createInvoice}</Button>
        </Link>
      </div>
      <div className="ml-auto">
        <InvoiceActions
          invoice={invoice}
          reload={reload}
          setError={(err: string) => {
            if (setError) {
              setError(err);
            }
          }}
        />
      </div>
    </div>
  </div>
);

export default PendingInvoiceListRow;
